import { render } from "./ConnectedVendor.vue?vue&type=template&id=71aea410&scoped=true"
import script from "./ConnectedVendor.vue?vue&type=script&lang=js"
export * from "./ConnectedVendor.vue?vue&type=script&lang=js"

import "./ConnectedVendor.vue?vue&type=style&index=0&id=71aea410&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71aea410"]])

export default __exports__